import type { IncidentClass } from "./types";

export const incidentClassLabels: Record<IncidentClass, string> = {
  silence: "Тишина",
  ignoring_team: "Команда игнорирует",
  ignoring_client: "Клиент игнорирует",
  SLA_violation: "Нарушение SLA",
  toxic_team: "Токсичность команды",
  toxic_client: "Токсичность клиента",
  negative_feedback: "Негативный отзыв",
  frustrated_client: "Растерянный клиент",
  pause_request: "Запрос на паузу",
  no_stats: "Нет статистики",
};
